/**
 * apps/web/src/lib/cn.ts
 *
 * Class-name combiner. Runs clsx (conditional composition) through
 * tailwind-merge so a caller's `className` override wins over a primitive's
 * base utilities instead of both landing in the DOM and fighting on source
 * order. Now that the primitives layer HeroUI recipe classes (buttonVariants,
 * ...) beneath caller overrides, the merge step is load-bearing.
 */

import clsx, { type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
